import { combineReducers } from '@reduxjs/toolkit';

import {
  ProductBrandDto,
  ProductCategoryDto,
  ProductUnitDto,
} from '../../../types/products';
import brandSlice from './brand/brand-slice';
import categorySlice from './category/category-slice';
import productSlice, { ProductStateDto } from './product/productSlice';
import unitSlice from './unit/unit-slice';

const reducer = combineReducers({
  brandSlice,
  productSlice,
  categorySlice,
  unitSlice,
});

export type ProductState = {
  brandSlice: ProductBrandDto;
  productSlice: ProductStateDto;
  categorySlice: ProductCategoryDto;
  unitSlice: ProductUnitDto;
};

export * from './brand/brand-slice';
export * from './category/category-slice';
export * from './product/productSlice';
export * from './unit/unit-slice';

export default reducer;
